import { render, staticRenderFns } from "./SummaryMessageBox.vue?vue&type=template&id=05d060bc&scoped=true&"
import script from "./SummaryMessageBox.vue?vue&type=script&lang=js&"
export * from "./SummaryMessageBox.vue?vue&type=script&lang=js&"
import style0 from "./SummaryMessageBox.vue?vue&type=style&index=0&id=05d060bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d060bc",
  null
  
)

export default component.exports